import { FromJSONable } from "./FromJSONable";

export class recaptcha implements FromJSONable{
    
    parseJSONObject(object:Object){
               
        if(!object){return;}
        Object.assign(this,object);
        this.success = object["success"];

      
    }

    success:string = "";
}